import { ArrowRight, Loader2 } from "lucide-react";
import { CompanySizeField, TextField, ContactNumberField } from "./fields";

// Step 1 (shown first): contact details. On continue we email these immediately.
export const ContactStep = ({ form, set, submitting, onContinue }) => (
    <form
        data-testid="wizard-step-contact"
        onSubmit={onContinue}
        className="space-y-5"
    >
        <CompanySizeField
            value={form.company_size}
            onChange={(e) => set("company_size", e.target.value)}
        />

        <div className="grid sm:grid-cols-2 gap-5">
            <TextField
                label="Name *"
                testId="name-input"
                value={form.name}
                onChange={(e) => set("name", e.target.value)}
                placeholder="Jane Doe"
            />
            <TextField
                label="Corporate Email *"
                testId="email-input"
                type="email"
                value={form.email}
                onChange={(e) => set("email", e.target.value)}
                placeholder="jane@company.com"
            />
        </div>

        <TextField
            label="Company Name *"
            testId="company-name-input"
            value={form.company_name}
            onChange={(e) => set("company_name", e.target.value)}
            placeholder="Acme Sdn Bhd"
        />

        <ContactNumberField form={form} set={set} />

        <button
            type="submit"
            data-testid="wizard-continue"
            disabled={submitting}
            className="group w-full font-mono text-sm tracking-[-0.01em] bg-neon text-black px-6 py-4 rounded-lg inline-flex items-center justify-center gap-2.5 hover:shadow-[0_0_26px_rgba(20,184,166,0.55)] transition-all disabled:opacity-60"
        >
            {submitting ? (
                <>
                    <Loader2 size={16} className="animate-spin" />
                    SENDING…
                </>
            ) : (
                <>
                    CONTINUE
                    <ArrowRight
                        size={16}
                        className="group-hover:translate-x-1 transition-transform"
                    />
                </>
            )}
        </button>
    </form>
);
